/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { CarbonDetailMeterField } from '../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import {
  convertDataForCarbonUtilityScopeOneSavingsMeter,
  flattenEmissionByScopeArray
} from '../../../shared/Utils/CarbonViewDetailsUtils';
import CarbonDetailTabBreakdownByFuel from '../../../shared/DetailBreakdownByFuel/CarbonDetailTabBreakdownByFuel';

import {
  ICarbonScopeOneSavingsByMeterDetailComponentProps,
  IFuelType
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import './CarbonScopeOneSavingsByMeterDetail.scss';
import { ConversionType } from '../../../shared/Utils/unitHandling/UnitModel';
import { ApiContext } from '../../../../context/ApiContext';

export const CarbonScopeOneSavingsByMeterDetailComponent = (
  props: ICarbonScopeOneSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const {
    data: { emissionMeasurementUnit, emissionsByScope },
    UtilityBillType,
    scope
  } = props;
  const apiContext = useContext(ApiContext);
  const flattenedEmissionBySubScope = flattenEmissionByScopeArray(
    emissionsByScope &&
      emissionsByScope.length &&
      emissionsByScope.filter(
        (ems: IFuelType) => ems.scope === CarbonDetailMeterField.scope1
      )[0].emissionsBySubScope
      ? emissionsByScope.filter(
          (ems: IFuelType) => ems.scope === CarbonDetailMeterField.scope1
        )[0].emissionsBySubScope
      : [],
    []
  );

  const progressBarRelativeWidth:
    | number
    | null
    | undefined = convertDataForCarbonUtilityScopeOneSavingsMeter(
    emissionMeasurementUnit,
    ConversionType.CARBON,
    JSON.parse(JSON.stringify(flattenedEmissionBySubScope))
  ).values[0].progessBarRelativeWidth;

  const meterSavingdata = convertDataForCarbonUtilityScopeOneSavingsMeter(
    emissionMeasurementUnit,
    ConversionType.CARBON,
    emissionsByScope,
    flattenedEmissionBySubScope,
    apiContext.showChangeWhenData
  );

  // const { values, displayUnit } = meterSavingdata;
  const values = meterSavingdata.values[0].emissionsBySubScope?.values;
  const displayUnit: any =
    meterSavingdata.values[0] && meterSavingdata.values[0].emissionsBySubScope
      ? meterSavingdata.values[0].emissionsBySubScope.displayUnit
      : [];
  const subUtilityMeasurementUnit =
    meterSavingdata.values[0].emissionsBySubScope?.values[0]
      ?.emissionsByFuelType?.displayUnit;

  const subUtilitycolumnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: CarbonDetailMeterField.fuelTypeName,
      header: t(d.FuelType),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonDetailMeterField.actualConsumption,
      header: t(d.ACTUALEMISSION),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonDetailMeterField.baselineConsumption,
      header: t(d.PREVIOUSEMISSION),
      sortable: true,
      initialWidth: '13%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonDetailMeterField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '7%'
    }
  ];

  const columnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: CarbonDetailMeterField.combustionType,
      header: scope && scope === 'scope 2' ? t(d.METERNAME) : t(d.FuelType),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonDetailMeterField.actualConsumption,
      header: t(d.ACTUALEMIS),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonDetailMeterField.baselineConsumption,
      header: t(d.PREVIOUSEMISSIONS),
      sortable: true,
      initialWidth: '13%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonDetailMeterField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '7%'
    }
  ];
  return (
    <div className="emaas-Metersaving-details-head">
      <CarbonDetailTabBreakdownByFuel
        subUtilityMeasurementUnit={displayUnit}
        meterData={values}
        utilityMeasurementUnit={displayUnit}
        columnDetails={columnDetails}
        utilityType={UtilityBillType}
        subUtilitycolumnDetails={subUtilitycolumnDetails}
        progressBarRelativeWidth={
          progressBarRelativeWidth ? progressBarRelativeWidth : 0
        }
        emissionMeasurementUnit={emissionMeasurementUnit}
      />
    </div>
  );
};
export default memo(CarbonScopeOneSavingsByMeterDetailComponent);
